var api = require("!../../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../node_modules/css-loader/dist/cjs.js??ref--5-oneOf-0-3!../../../../node_modules/postcss-loader/src/index.js??ref--5-oneOf-0-4!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/fast-sass-loader/lib/index.js??ref--5-oneOf-0-6!./wrapper.scss");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);

var exported = content.locals ? content.locals : {};



module.exports = exported;